module.exports = [{
      plugin: require('/codebuild/output/src636046314/src/seadream-booking/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/codebuild/output/src636046314/src/seadream-booking/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
